import { render, staticRenderFns } from "./OrdenesCompraCRUD.vue?vue&type=template&id=225a73ba"
import script from "./OrdenesCompraCRUD.vue?vue&type=script&lang=js"
export * from "./OrdenesCompraCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports